import React, { useState, useEffect, useContext, useMemo } from "react";
import { pdfHeader, pdfTableStyles, pdfFooter, pdfNotaVenta, pdfCliente, pdfDireccion, pdfFilasTotales, NOTA_CONDICIONES, NOTA_PAGARE, NOTA_LEYENDA } from "../../../../pdfUtils";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import axios from "axios";
import Baja from "../../Baja";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import qrcode from "qrcode-js";
import { v4 as uuidv4 } from "uuid";
import moment from "moment";

function ListadoVentas() {
  const { user } = useContext(AuthContext);
  const URL_SURTIDOS = process.env.REACT_APP_URL_SURTIDOS;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_COLABORADORES = process.env.REACT_APP_URL_COLABORADORES;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const URL_SEND_MAIL_ATT_DOBLE = process.env.REACT_APP_URL_SEND_MAIL_ATT_DOBLE;
  const URL_ARTICULOS_SURTIDOS = process.env.REACT_APP_URL_ARTICULOS_SURTIDOS;
  const URL_DEPARTAMENTOS_CLIENTES =
    process.env.REACT_APP_URL_DEPARTAMENTOS_CLIENTES;
  /* WhatsApp desactivado por ahora
const URL_WHATSAPP = process.env.REACT_APP_URL_WHATSAPP;
*/
  const URL_ZONAS = process.env.REACT_APP_URL_ZONAS;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;

  let hoy = new Date();
  let inicio = new Date();
  inicio.setDate(inicio.getDate() - 30);

  let endDate = moment(hoy).format("YYYY-MM-DD");
  let startDate = moment(inicio).format("YYYY-MM-DD");


  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");
  const [colaboradores, setColaboradores] = useState([]);
  const [selectedColaborador, setSelectedColaborador] = useState("");
  const [selectedUser, setSelectedUser] = useState("");
  const [selectedActivo, setSelectedActivo] = useState("");

  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);

  const [zonas, setZonas] = useState([]);
  const [selectedZona, setSelectedZona] = useState("");
  const [selectedEntregado, setSelectedEntregado] = useState("");
  const [departamentos, setDepartamentos] = useState([]);
  const [selectedDepartamento, setSelectedDepartamento] = useState("");

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [activo, setActivo] = useState("");
  const [subTotalImporteTabla, setSubTotalImporteTabla] = useState(0);
  const [totalImporteTabla, setTotalImporteTabla] = useState(0);
  const [totalPiezasTabla, setTotalPiezasTabla] = useState(0);

  // Editar observaciones de una nota desde el listado
  const [modalObs, setModalObs] = useState(false);
  const toggleObs = () => setModalObs(!modalObs);
  const [obsId, setObsId] = useState("");
  const [obsNumero, setObsNumero] = useState("");
  const [obsTexto, setObsTexto] = useState("");

  const [idEdit, setIdEdit] = useState("");
  const [clienteEdit, setClienteEdit] = useState("");
  const [numeroEdit, setNumeroEdit] = useState("");
  const [facturaEdit, setFacturaEdit] = useState("");
  const [modalEditNota, setModalEditNota] = useState(false);
  const toggleEditNota = () => setModalEditNota(!modalEditNota);

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  useEffect(() => {
    axios
      .get(URL_CLIENTES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allClientes = response.data;
        setClientes(allClientes);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_COLABORADORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allColaboradores = response.data;
        setColaboradores(allColaboradores);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_DEPARTAMENTOS_CLIENTES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allDepartamentos = res.data;
        setDepartamentos(allDepartamentos);
      })
      .catch((err) => {
        console.log(err);
      });
      
      axios
      .get(URL_ZONAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        setZonas(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useMemo(() => {
    axios
      .get(`${URL_SURTIDOS}Fechas/${selectedFechaInicio}/${selectedFechaFin}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allSurtidos = response.data;
        // Array para pagination
        let arrayTabla = allSurtidos
          .sort((a, b) => (a.idSurtido < b.idSurtido ? 1 : -1))
          .map((a) => {
            // Accesos seguros: si algun ref esta borrado, no truena la vista
            const usr = a.user?.[0] || {};
            const ped = a.pedidos?.[0] || {};
            const pedCli = ped.clientes?.[0] || {};
            const pedCol = ped.colaboradores?.[0] || {};
            const cli = a.clientes?.[0] || {};
            const depto = cli.departamentosClientes?.[0] || {};
            const ar = a.areas?.[0] || {};
            const zona = cli.zonas?.[0] || {};
            return {
              _id: a._id,
              is_active: a.is_active,
              fecha: a.fecha,
              user: (usr.nombre || "") + " " + (usr.apellido || ""),
              idUser: usr._id,
              pedidos: ped.idPedido,
              idPedido: ped._id,
              clientes: pedCli.nombre_comercial,
              codigoClientes: pedCli.codigo,
              idClientes: pedCli._id,
              observaciones: a.observaciones,
              numero: a.idSurtido,
              comisionTDC: ped.comisionTDC,
              comisionFlete: a.flete,
              impuestos: a.impuestos,
              descuento: a.descuento,
              subTotal: a.subTotal,
              ieps: a.ieps,
              iva: a.iva,
              total_general: a.total_general,
              calle: cli.calle,
              numero_ext: cli.numero_ext,
              numero_int: cli.numero_int,
              pais: cli.pais,
              estado: cli.estado,
              ciudad: cli.ciudad,
              delegacion: cli.delegacion,
              colonia: cli.colonia,
              cp: cli.cp,
              paqueteria: cli.paqueteria,
              RFC: cli.RFC,
              area: ar.name,
              vendedor: (pedCol.nombre || "") + " " + (pedCol.apellido || ""),
              idVendedor: pedCol._id,
              telefono: cli.telefono,
              idDepartamento: depto._id,
              departamentoName: depto.name,
              zona: zona.name || "",
              idZona: zona._id || "",
              entregado: a.entregado || "No",
              fechaEntrega: a.fechaEntrega || "",
              plazo: cli.plazo,
              total_cantidad: a.total_cantidad,
              flete: a.flete,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);
        setComments(dataFinal);
        //
      })
      .catch((err) => {
        console.log(err);
      });
  }, [selectedFechaInicio, selectedFechaFin]);

  // Los mismos filtros de la tabla para pantalla, PDF, Excel y correo
  function aplicaFiltros(lista) {
    const q = search.toLowerCase();
    return lista.filter(
      (e) =>
        (!search ||
          [e.clientes, e.zona, e.area, e.vendedor, e.pedidos, e.numero, e.subTotal, e.total_general].some((v) =>
            String(v ?? "").toLowerCase().includes(q)
          )) &&
        (!selectedCliente || e.idClientes === selectedCliente) &&
        (!selectedZona || e.idZona === selectedZona) &&
        (!selectedEntregado || (e.is_active === "Si" && e.entregado === selectedEntregado)) &&
        (!selectedColaborador || e.idVendedor === selectedColaborador) &&
        (!selectedUser || e.idUser === selectedUser) &&
        (!selectedActivo || e.is_active === selectedActivo) &&
        (!selectedDepartamento || e.idDepartamento === selectedDepartamento) &&
        (!selectedFechaInicio || e.fecha >= selectedFechaInicio) &&
        (!selectedFechaFin || e.fecha <= selectedFechaFin)
    );
  }

  const fmtPesos = (v) =>
    new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(v || 0);

  function pdfListado() {
    const doc = new jsPDF("landscape", "mm", "a4", true);
    const inicioPDF = pdfHeader(doc, `Listado de Ventas`, `${selectedFechaInicio} - ${selectedFechaFin}`);
    doc.autoTable({
      ...pdfTableStyles(),
      startY: inicioPDF,
      head: [["Numero", "Fecha", "Cliente", "Zona", "Vendedor", "SubTotal", "Importe", "Botellas", "Entregado"]],
      body: aplicaFiltros(comments).map((a) =>
        a.is_active === "Si"
          ? [a.numero, a.fecha, a.clientes, a.zona, a.vendedor, fmtPesos(a.subTotal), fmtPesos(a.total_general),
             new Intl.NumberFormat("en-US").format(a.total_cantidad), a.entregado === "Si" ? a.fechaEntrega || "Si" : "No"]
          : [a.numero, a.fecha, a.clientes, a.zona, a.vendedor, "CANCELADA", 0, 0, ""]
      ),
      foot: [["", "", "", "", "Total", fmtPesos(subTotalImporteTabla), fmtPesos(totalImporteTabla),
              new Intl.NumberFormat("en-US").format(totalPiezasTabla), ""]],
      showFoot: "lastPage",
    });
    pdfFooter(doc);
    return doc;
  }

  function PDFTabla() {
    pdfListado().save(`Ventas.pdf`);
  }

  function excel() {
    const campos = ["Numero", "Fecha", "Cliente", "Zona", "Almacen", "Vendedor", "SubTotal", "Importe", "Botellas", "Entregado", "FechaEntrega"];
    const hoja = aplicaFiltros(comments).map((a) => ({
      Numero: a.numero,
      Fecha: a.fecha,
      Cliente: a.clientes,
      Zona: a.zona,
      Almacen: a.area,
      Vendedor: a.vendedor,
      SubTotal: a.is_active === "Si" ? a.subTotal : "CANCELADA",
      Importe: a.is_active === "Si" ? a.total_general : 0,
      Botellas: a.total_cantidad,
      Entregado: a.is_active === "Si" ? a.entregado : "",
      FechaEntrega: a.fechaEntrega,
    }));
    const option = {
      fileName: "ListadoVentas",
      datas: [{ sheetData: hoja, sheetName: "ListadoVentas", sheetFilter: campos, sheetHeader: campos }],
    };
    new ExportJsonExcel(option).saveExcel();
  }

  function enviaMail() {
    const doc = pdfListado();
    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado de Ventas",
          email: mailTo,
          fileName: "ListadoVentas.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Notas.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Listo", "Enviado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Algo salio mal",
          text: "No se pudo completar",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  // Regresa inventario, lotes, pedido y saldo; el back rechaza si ya tiene cobros
  async function cancelarNota(id, numero) {
    const ok = await Swal.fire({
      title: `¿Cancelar la nota ${numero}?`,
      text: "Regresa el vino al inventario y quita el saldo del cliente",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, cancelar",
      cancelButtonText: "No",
    });
    if (!ok.value) return;
    try {
      await axios.patch(`${URL_SURTIDOS}Cancelar/${id}`, {}, { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } });
      setComments((prev) => prev.map((x) => (x._id === id ? { ...x, is_active: "No" } : x)));
      Swal.fire("Nota cancelada", "", "success");
    } catch (error) {
      Swal.fire({ icon: "error", title: "No se cancelo", text: error.response?.data?.message || "Intenta de nuevo" });
    }
  }

  // El repartidor marca lo que va entregando: cambia solo el renglon, sin recargar
  async function marcarEntregado(a) {
    const entregado = a.entregado === "Si" ? "No" : "Si";
    const fija = (valor, fecha) =>
      setComments((prev) => prev.map((x) => (x._id === a._id ? { ...x, entregado: valor, fechaEntrega: fecha } : x)));
    fija(entregado, entregado === "Si" ? moment().format("YYYY-MM-DD") : "");
    try {
      const { data } = await axios.patch(
        `${URL_SURTIDOS}Entregar/${a._id}`,
        { entregado },
        { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
      );
      fija(data.entregado, data.fechaEntrega);
    } catch (error) {
      fija(a.entregado, a.fechaEntrega);
      Swal.fire({ icon: "error", title: "No se marco la entrega", text: error.response?.data?.message || "Revisa tu conexion e intenta de nuevo" });
    }
  }

  async function PDFOC(
    fecha,
    idClientes,
    clientes,
    observaciones,
    numero,
    idPDFOC,
    user,
    pedidos,
    comisionTDC,
    comisionFlete,
    impuestos,
    subTotal,
    ieps,
    iva,
    total_general,
    calle,
    numero_ext,
    numero_int,
    pais,
    estado,
    ciudad,
    delegacion,
    colonia,
    cp,
    RFC,
    paqueteria,
    area,
    codigoClientes,
    vendedor,
    telefono,
    descuento
  ) {
    try {
      const response = await axios
      .get(`${URL_ARTICULOS_SURTIDOS}/surtido/${idPDFOC}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
        let allArticulosSurtido = response.data;
        let arrayTabla = allArticulosSurtido
          .map((a) => {
            return {
              id: a.inventarios[0]._id,
              codigo: a.articulos[0].codigo,
              articulos: a.articulos[0].nombre,
              cantidad: a.cantidad,
              idArticulo: a.articulos[0]._id,
              precio: a.articulosPedido[0].precio,
              cajas: a.cantidad / a.articulos[0].piezasPorCaja,
              fotoArticulo: a.articulos[0].foto,
              foto: ""
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);

        let agrupado = dataFinal.reduce(function (groups, item) {
          const val = item["idArticulo"];
          groups[val] = groups[val] || {
            idArticulo: item.idArticulo,
            cantidad: 0,
            cajas: 0,
          };
          groups[val].cantidad += item.cantidad;
          groups[val].cajas += item.cajas;
          groups[val].articulos = item.articulos;
          groups[val].precio = item.precio;
          groups[val].codigo = item.codigo;
          groups[val].foto = item.foto;
          groups[val].fotoArticulo = item.fotoArticulo;
          return groups;
        }, []);

        let agrupadoValues = Object.values(agrupado);

        let totalMts = agrupadoValues.map((c) => parseFloat(c.cantidad));
        let TM = totalMts.reduce((t, total, index) => t + total, 0);

        let TC = agrupadoValues.map((c) => parseFloat(c.cajas));
        let TTC = TC.reduce((t, total, index) => t + total, 0);

        let totalParcial = 0;

        const imagePromises = agrupadoValues.map(async (z) => {
          return (async () => {
            if (z.fotoArticulo === "Si") {
              try {
                const imgResponse = await axios.get(`${process.env.REACT_APP_URL_GETMEDIA}/${z.idArticulo}`, {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                  },
                });
                z.foto = imgResponse.data.secure_url || process.env.PUBLIC_URL + "sinImagen.png";
              } catch (error) {
                console.error("Error al cargar imagen:", error);
                z.foto = process.env.PUBLIC_URL + "sinImagen.png";
              }
            } else {
              z.foto = process.env.PUBLIC_URL + "sinImagen.png";
            }
          })();
        });
        
        await Promise.all(imagePromises);
       

        setTimeout(() => {

        const data = agrupadoValues.map((a) => {
          totalParcial = a.cantidad * a.precio;
          return [
            a.foto,
            new Intl.NumberFormat("en-US").format(a.cantidad),
            a.codigo,
            a.articulos,
            new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 }).format(
              a.cantidad
            ) + " / " + new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 }).format(a.cajas) + " Cajas",
            new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              maximumFractionDigits: 2,
            }).format(a.precio),
            new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              maximumFractionDigits: 2,
            }).format(totalParcial),
          ];
        });

        const dataPDF = Object.values(data);
        const dataPDFLimpia = dataPDF.filter(function (el) {
          return el != null;
        });

        const doc = new jsPDF({ compressPdf: true });
        pdfNotaVenta(doc, {
          titulo: "Nota de venta",
          folio: numero,
          fecha: `Ciudad de México, ${fecha}`,
          cliente: pdfCliente(`${codigoClientes} - ${clientes}`, telefono, pdfDireccion(calle, numero_ext, numero_int, estado, ciudad, cp)),
          datos: [`Pedido ${pedidos}`, `Almacen ${area}`, `Vendedor ${vendedor}`],
          foto: true,
          head: ["Foto", "Vino", "Descripcion", "Botellas / Cajas", "Precio", "Importe"],
          body: dataPDFLimpia.map((f) => [f[0], f[2], f[3], f[4], f[5], f[6]]),
          totales: pdfFilasTotales({
            botellas: TM,
            subTotal,
            descuento: (subTotal * descuento) / 100,
            descuentoPct: descuento,
            flete: comisionFlete + comisionTDC,
            ieps,
            iva,
            total: total_general,
          }),
          observaciones,
          condiciones: NOTA_CONDICIONES,
          pagare: NOTA_PAGARE,
          leyenda: NOTA_LEYENDA,
        });
        pdfFooter(doc);
        doc.save(`Nota-${numero}.pdf`);
        //   }
        // });
        // });
    }, 1000);
      
    } catch (err) {
      console.error("Error al obtener datos del surtido:", err);
    }
  }


  // Fija a la derecha: en el celular del repartidor siempre queda a la vista
  const colEntregado = { whiteSpace: "nowrap", position: "sticky", right: 0, background: "#fff", zIndex: 1 };

  const headers = [
    { name: "Numero", field: "numero", sortable: true },
    { name: "Fecha", field: "fecha", sortable: true },
    { name: "Cliente", field: "clientes", sortable: true },
    { name: "Zona", field: "zona", sortable: true },
    { name: "Almacen", field: "area", sortable: true },
    { name: "Vendedor", field: "vendedor", sortable: true },
    { name: "SubTotal", field: "subTotal", sortable: true },
    { name: "Total", field: "total_general", sortable: true },
    { name: "Botellas", field: "total_cantidad", sortable: true },
    { name: "Detalles", field: "acciones", sortable: false },
    { name: "Entregado", field: "entregado", sortable: true },
  ];

  const commentsData = useMemo(() => {
    let computedComments = aplicaFiltros(comments);

    let activos = computedComments.filter((e) => e.is_active == "Si");

    let cant = activos.map((c) => parseFloat(c.total_cantidad));
    let TC = cant.reduce((t, total, index) => t + total, 0);
    setTotalPiezasTabla(TC);

    let sub = activos.map((c) => parseFloat(c.subTotal));
    let TS = sub.reduce((t, total, index) => t + total, 0);
    setSubTotalImporteTabla(TS);

    let to = activos.map((c) => parseFloat(c.total_general));
    let TT = to.reduce((t, total, index) => t + total, 0);
    setTotalImporteTabla(TT);

    setTotalItems(computedComments.length);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "pedidos" &&
      sorting.field != "numero" &&
      sorting.field != "total_cantidad" &&
      sorting.field != "subTotal" &&
      sorting.field != "total_general"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * String(a[sorting.field] ?? "").localeCompare(String(b[sorting.field] ?? ""))
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "pedidos" ||
        sorting.field == "numero" ||
        sorting.field == "total_cantidad" ||
        sorting.field == "subTotal" ||
        sorting.field == "total_general")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "pedidos" ||
        sorting.field == "numero" ||
        sorting.field == "total_cantidad" ||
        sorting.field == "subTotal" ||
        sorting.field == "total_general")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedCliente,
    selectedZona,
    selectedEntregado,
    selectedColaborador,
    selectedUser,
    selectedFechaInicio,
    selectedFechaFin,
    selectedDepartamento,
    selectedActivo
  ]);

  function abrirObservaciones(a) {
    setObsId(a._id);
    setObsNumero(a.numero);
    setObsTexto(a.observaciones && a.observaciones !== "NA" ? a.observaciones : "");
    toggleObs();
  }

  function guardarObservaciones() {
    // El validador no acepta texto vacio; "NA" es el valor por defecto del sistema
    const texto = obsTexto.trim() || "NA";
    axios
      .patch(
        `${URL_SURTIDOS}/${obsId}`,
        { observaciones: texto },
        { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
      )
      .then(() => {
        setComments((prev) =>
          prev.map((x) => (x._id === obsId ? { ...x, observaciones: texto } : x))
        );
        toggleObs();
        Swal.fire({ icon: "success", title: "Observaciones guardadas", showConfirmButton: false, timer: 1200 });
      })
      .catch((error) => {
        Swal.fire({ icon: "error", title: "Algo salio mal", text: "No se pudieron guardar las observaciones" });
        console.log(error);
      });
  }

    function EditNota(id, clientes, numero, factura) {

    setIdEdit(id);
    setClienteEdit(clientes);
    setNumeroEdit(numero);
    setFacturaEdit(factura);

    toggleEditNota();
  }

    function saveEditarNota(){
    axios.patch(
      `${URL_SURTIDOS}/${idEdit}`,
      {
        noFactura: facturaEdit,
      },
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem(
            "app_token"
          )}`,
        },
      }
    )
    .then(() => {
      axios.post(
        URL_LOGS,
        {
          tipo: "Editar Nota",
          detalle: `${numeroEdit} ${clienteEdit}`,
          user: user.id,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );
      // axios.patch(
      //   URL_SIGNUP_DON,
      //   {
      //     nombre: nombre,
      //     apellido: apellido,
      //     email: email,
      //   },
      //   {
      //     headers: {
      //       Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      //     },
      //   }
      // );
      toggleEditNota();
      Swal.fire("Listo", "Actualizado con exito", "success");
      // setTimeout(() => {
      //   window.location.reload();
      // }, 1000);
    })


    .catch((error) => {
      Swal.fire({
        icon: "error",
        title: "Algo salio mal",
        text: "No se pudo completar",
      });
      console.log(error);
    });



  }



  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_ventas ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              <Button
                size="sm"
                href="/MenuVentas"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            <Col sm={4}>
              {user.exportar ? (
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
              ) : null}
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Listado de Ventas</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>
          <h3 align="center">Ventas</h3>
          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Inicio</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                required
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Fin</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin}
                required
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label>Zona</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedZona}
                onChange={(e) => {
                  setSelectedZona(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Todas</option>
                {zonas.map((a) => (
                  <option key={a._id} value={a._id}>{a.name}</option>
                ))}
              </Input>
            </Col>
            <Col md={2}>
              <Label>Entregado</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedEntregado}
                onChange={(e) => {
                  setSelectedEntregado(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Todas</option>
                <option value="No">Pendientes</option>
                <option value="Si">Entregadas</option>
              </Input>
            </Col>
            <Col md={2}>
              <Label>Clientes</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedCliente}
                onChange={(e) => {
                  setSelectedCliente(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Selecciona</option>
                {clientes
                  .sort((a, b) =>
                    a.nombre_comercial > b.nombre_comercial ? 1 : -1
                  )
                  .map((a) => {
                    return <option value={a._id}>{a.nombre_comercial}</option>;
                  })}
              </Input>
            </Col>
            <Col md={2}>
              <Label>Vendedores</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedColaborador}
                onChange={(e) => {
                  setSelectedColaborador(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Selecciona</option>
                {colaboradores
                  .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                  .map((a) => {
                    return (
                      <option value={a._id}>
                        {a.nombre} {a.apellido}
                      </option>
                    );
                  })}
              </Input>
            </Col>
            <Col md={2}>
              <Label>Activa</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedActivo}
                onChange={(e) => {
                  setSelectedActivo(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Selecciona</option>
                <option value="Si">Si</option>
                <option value="No">No</option>
              </Input>
            </Col>
          </Row>
          <br />
          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tbody>
              {commentsData.map((a) => {
                if (a.is_active == "No") {
                  return (
                    <tr style={{ backgroundColor: "#ed8c8c" }}>
                      <td>{a.numero}</td>
                      <td>{a.fecha}</td>
                      <td>{a.clientes}</td>
                      <td>{a.zona}</td>
                      <td>{a.area}</td>
                      <td>{a.vendedor}</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td>CANCELADA</td>
                    </tr>
                  );
                } else {
                  return (
                    <tr>
                      <td>{a.numero}</td>
                      <td>{a.fecha}</td>
                      <td>{a.clientes}</td>
                      <td>{a.zona}</td>
                      <td>{a.area}</td>
                      <td>{a.vendedor}</td>
                      <td>
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          maximumFractionDigits: 2,
                        }).format(a.subTotal)}
                      </td>
                      <td>
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          maximumFractionDigits: 2,
                        }).format(a.total_general)}
                      </td>
                      <td>
                        {new Intl.NumberFormat("en-US", {}).format(
                          a.total_cantidad
                        )}
                      </td>
                      <td style={{ whiteSpace: "nowrap" }}>
                        <>
                          {/* <Button
                        color="info"
                        id="Editar"
                        size="sm"
                        onClick={(e) =>
                          EditNota(
                            a._id,
                            a.clientes,
                            a.numero,
                            a.noFactura,
                          )
                        }
                      >
                        <i class="far fa-edit"></i>
                      </Button> */}
                          <Button
                            disabled={!user.imprimir}
                            size="sm"
                            className="btn"
                            color="danger"
                            onClick={(e) =>
                              PDFOC(
                                a.fecha,
                                a.idClientes,
                                a.clientes,
                                a.observaciones,
                                a.numero,
                                a._id,
                                a.user,
                                a.pedidos,
                                a.comisionTDC,
                                a.comisionFlete,
                                a.impuestos,
                                a.subTotal,
                                a.ieps,
                                a.iva,
                                a.total_general,
                                a.calle,
                                a.numero_ext,
                                a.numero_int,
                                a.pais,
                                a.estado,
                                a.ciudad,
                                a.delegacion,
                                a.colonia,
                                a.cp,
                                a.RFC,
                                a.paqueteria,
                                a.area,
                                a.codigoClientes,
                                a.vendedor,
                                a.telefono,
                                a.descuento
                              )
                            }
                          >
                            <i class="far fa-file-pdf"></i>
                          </Button>
                          {user.ventas_observaciones ? (
                          <Button
                            color="info"
                            size="sm"
                            title="Editar observaciones"
                            onClick={() => abrirObservaciones(a)}
                          >
                            <i className="far fa-comment"></i>
                          </Button>
                          ) : null}
                          {/* <Button
                              size="sm"
                              className="btn"
                              color="success"
                              onClick={(e) =>
                                enviarWhatsapp(
                                  a.fecha,
                                  a.idClientes,
                                  a.clientes,
                                  a.observaciones,
                                  a.numero,
                                  a._id,
                                  a.user,
                                  a.pedidos,
                                  a.comisionTDC,
                                  a.comisionFlete,
                                  a.impuestos,
                                  a.subTotal,
                                  a.ieps,
                                  a.iva,
                                  a.total_general,
                                  a.calle,
                                  a.numero_ext,
                                  a.numero_int,
                                  a.pais,
                                  a.estado,
                                  a.ciudad,
                                  a.delegacion,
                                  a.colonia,
                                  a.cp,
                                  a.RFC,
                                  a.paqueteria,
                                  a.area,
                                  a.codigoClientes,
                                  a.vendedor,
                                  a.telefono
                                )
                              }
                            >
                              <i class="fab fa-whatsapp"></i>
                            </Button> */}

                         <Button
  size="sm"
  className="btn"
  color="danger"
  disabled={!user?.cancelarNotas}
  onClick={() =>
    user?.cancelarNotas &&
    cancelarNota(a._id, a.numero)
  }
  title={!user?.cancelarNotas ? "No tienes permisos para cancelar notas" : ""}
>
  <i className="fas fa-ban"></i>
</Button>

                        </>
                      </td>
                      <td style={colEntregado}>
                        <Button
                          size="sm"
                          color={a.entregado === "Si" ? "success" : "secondary"}
                          disabled={!user.entregarNotas}
                          title={a.entregado === "Si" ? `Entregado ${a.fechaEntrega}. Clic para desmarcar` : "Marcar como entregado"}
                          onClick={() => marcarEntregado(a)}
                        >
                          <i className={a.entregado === "Si" ? "fas fa-check" : "fas fa-truck"} />{" "}
                          {a.entregado === "Si" ? "Entregado" : "Entregar"}
                        </Button>
                        {a.entregado === "Si" && a.fechaEntrega ? (
                          <div style={{ fontSize: 11, color: "#64748b" }}>{a.fechaEntrega}</div>
                        ) : null}
                      </td>
                    </tr>
                  );
                }
              })}
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td className="negrita" align="center">
                  TOTAL
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    maximumFractionDigits: 2,
                  }).format(subTotalImporteTabla)}
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    maximumFractionDigits: 2,
                  }).format(totalImporteTabla)}
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {
                  }).format(totalPiezasTabla)}
                </td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>

          <Modal size="md" isOpen={modalObs} toggle={toggleObs}>
            <ModalHeader toggle={toggleObs}>
              <h4>Observaciones Nota {obsNumero}</h4>
            </ModalHeader>
            <ModalBody>
              <Label>Observaciones</Label>
              <Input type="textarea" rows="4" value={obsTexto} onChange={(e) => setObsTexto(e.target.value)} />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={guardarObservaciones}>
                Guardar
              </Button>
            </ModalFooter>
          </Modal>

                <Modal size="sm" isOpen={modalEditNota} toggle={toggleEditNota}>
        <ModalHeader toggle={toggleEditNota}>
          <h4>Editar Nota {numeroEdit} Cliente {clienteEdit} </h4>
        </ModalHeader>
        <ModalBody>
        <Row>
                <Col md={6}>
              <Label for="exampleEmail" className="mr-sm-2">
                Factura
              </Label>
              <Input
                bsSize="sm"
                type="text"
                value={facturaEdit}
                onChange={(e) => {
                  setFacturaEdit(e.target.value);
                }}
              />
              </Col>
            
             
            </Row>
            <br />
            <br />
          <Button size="sm" color="success" onClick={e=>saveEditarNota()} tabindex="-1">
            Guardar
          </Button>
        </ModalBody>
      </Modal>
        </div>
      ) : undefined}
      <br />
      {loader}
    </>
  );
}

export default ListadoVentas;
